import {State} from '../reducer';
import {createSelector} from 'reselect';
import {IStatesResponse} from 'types/StatesResponse';
import {enums} from 'types/enums';
import {layoutSelectors} from 'features/layout/redux';

const isSyncFolderSuspended = createSelector(
   (state: State) => state.layout.states,
   (states: IStatesResponse) => states.foldersMap?.Synchronization?.typeId === enums.State.SUSPENDED
);

const synchronizationsCount = createSelector(
   layoutSelectors.synchronizationsSelector,
   (users) => users.length
);

export default {
   synchronizationsSelector: layoutSelectors.synchronizationsSelector,
   isSyncFolderSuspended,
   synchronizationsCount,
};
